export const WEEKDAY_MAPPING = {
    0: "周日",
    1: "周一",
    2: "周二",
    3: "周三",
    4: "周四",
    5: "周五",
    6: "周六",
  };


//////////////////
// WEBPACK FOOTER
// ./app/contants/time.js
// module id = null
// module chunks = 